/**
 * Product description stored mainly as HTML in `description` (sanitized) or legacy JSON in `descriptionRich`.
 */

import { sanitizeProductDescriptionHtml } from './sanitizeProductHtml';

const HTML_LIKE = /<\/?[a-z][\s\S]*>/i;

export function isLikelyHtmlDescription(text) {
  if (typeof text !== 'string' || !text.trim()) return false;
  return HTML_LIKE.test(text);
}

export function stripHtmlToPlain(html) {
  if (typeof html !== 'string' || !html.trim()) return '';
  if (typeof window === 'undefined' || typeof DOMParser === 'undefined') {
    return html.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
  }
  try {
    const doc = new DOMParser().parseFromString(`<div>${html}</div>`, 'text/html');
    return doc.body.textContent?.replace(/\s+/g, ' ').trim() || '';
  } catch {
    return html.replace(/<[^>]+>/g, ' ').trim();
  }
}

/** For required-field validation: use visible text length, not raw HTML length. */
export function descriptionPlainForValidation(descriptionField) {
  if (typeof descriptionField !== 'string') return '';
  const t = descriptionField.trim();
  if (!t) return '';
  if (isLikelyHtmlDescription(t)) {
    return stripHtmlToPlain(sanitizeProductDescriptionHtml(t));
  }
  return t;
}
